import { useEffect, useState } from "react";
import { useRouter } from "next/router";

import { AscButton, AscSearchInput } from "@ascendnow/ascend-components";
import styles from "./AscPostSearch.module.scss";

export const AscPostSearch = () => {
  const router = useRouter();
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (router.query.search) {
      setInputValue(router.query.search as string);
    }
  }, [router.query.search]);

  return (
    <div className={styles.search}>
      <AscSearchInput
        value={inputValue}
        placeholder="Search by name..."
        onChange={(event) => setInputValue(event.target.value)}
        className={styles.searchInput}
        inputWrapperClassName={styles.searchInputWrapper}
      />
      <AscButton
        type="button"
        className={styles.searchButton}
        onClick={() => {
          router.query.search = inputValue;
          router.push(router);
        }}
      >
        Search
      </AscButton>
    </div>
  );
};
